module.exports = __webpack_public_path__ + "static/media/inf_72og73.346eea47.mp3";